module.exports = __webpack_public_path__ + "static/fipcwhiteabc4-b1da55a20c437794e962571c3d25decd.jpeg";